var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-process-area section-space--pb_120"},[_c('div',{staticClass:"container"},[_c('SectionTitle',{attrs:{"sectionTitle":"The 3-step process"}}),_c('Gradation')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }